// extracted by mini-css-extract-plugin
export default {"page":"CrashErrorPage_page__E5EE6"};